import React from 'react';
import HeaderView from '../header/header-dcs.view.jsx';
import LoadingWithApiQueue from '../loading/loading-with-queue.view';

export default class LayoutMapPageView extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="layout-map-page-container">
                <HeaderView match={this.props.match} />
                <div>
                    {this.props.children}
                </div>
                <LoadingWithApiQueue />
            </div>
        )
    }
}

